import Vue from 'vue';
import Component from 'vue-class-component';
import Watch from '../../Icons/Watch.vue';
import Coupon from '../../Icons/Coupon.vue';
import Ticket from '../../Icons/Ticket.vue';
@Component({
  components: {Coupon, Watch, Ticket},
})

export default class HeaderIcons extends Vue {
}
